// import { createSlice } from "@reduxjs/toolkit";
// import toast from "react-hot-toast";

// const initialState = {
//   cartItems: localStorage.getItem("cartItems")
//     ? JSON.parse(localStorage.getItem("cartItems"))
//     : [],
//   cartTotalQuantity: 0,
//   cartTotalAmount: 0,
//   selectedNicotineLevel:0
// };

// export const CartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {
//     addToCart(state, action) {
//       const product = state.cartItems.findIndex(
//         (item) => item._id === action.payload._id &&
//         item.selectedNicotineLevel === action.payload.selectedNicotineLevel
//       );
//       if (product >= 0) {
//         state.cartItems[product].cartQuantity += 1;
//       // } else {
//         // const author = state.cartItems[0]?.author;
//         // const productAuthor = action.payload?.author;
//         // if(author){
//         //   if(author?._id === productAuthor?._id){
//             const tempProduct = { ...action.payload, cartQuantity: 1,selectedNicotineLevel: action.payload.selectedNicotineLevel, };
//             state.cartItems.push(tempProduct);
//           // }else{
//           //   toast.error(`You can add only ${author?.name} products`);
//           // }
//         }else{
//           const tempProduct = { ...action.payload, cartQuantity: 1 ,selectedNicotineLevel: action.payload.selectedNicotineLevel};
//           state.cartItems.push(tempProduct);
//         }
      
//       toast.success('Item added to cart');
//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },

//     removeFromCart(state, action) {
//       state.cartItems.map((cartItem) => {
//         if (cartItem._id === action.payload._id) {
//           const nextCartItems = state.cartItems.filter(
//             (item) => item._id !== cartItem._id
//           );

//           state.cartItems = nextCartItems;
//         }
//         // toast.success('Item removed from cart');
//         localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//         return state;
//       });
//     },
//     decreaseCart(state, action) {
//       const itemIndex = state.cartItems.findIndex(
//         (item) => item._id === action.payload._id
//       );


//       if (state.cartItems[itemIndex].cartQuantity > 1) {
//         state.cartItems[itemIndex].cartQuantity -= 1;
//       }else{
//         const nextCartItems = state.cartItems.filter(
//           (item) => item._id !== state.cartItems[itemIndex]._id
//         );
//         toast.success('Item removed from cart');
//         state.cartItems = nextCartItems; 
//       }
//       // toast.success('Item removed from cart');
//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },
//     incrementCart(state, action) {
//       const product = state.cartItems.findIndex(
//         (item) => item._id === action.payload._id &&
//         item.selectedNicotineLevel === action.payload.product.selectedNicotineLevel 
//       );
//       if (product >= 0 ) {
//         if(state.cartItems[product].quantity > state.cartItems[product].cartQuantity){
//           state.cartItems[product].cartQuantity += 1;
//         }else{
//           toast.error('No more stock available');
//         }
//       } else {
//         const tempProduct = { ...action.payload, cartQuantity: 1 };
//         state.cartItems.push(tempProduct);
//       }
//      toast.success("Item added to cart")
//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },
//     addByIncrement(state, action) {
//       console.log("addByIncrement Payload:", action.payload); // Debug log
//       const product = state.cartItems.findIndex(
//         (item) => item._id === action.payload.product._id
//       );
//       if (product >= 0) {
//         state.cartItems[product].cartQuantity +=action.payload.cartQuantity;
//       } else {
//         const cartQuantity = action.payload.cartQuantity===1?1:action.payload.cartQuantity 
//         const tempProduct = { ...action.payload.product,cartQuantity, selectedNicotineLevel: action.payload.selectedNicotineLevel};
//         console.log("Product Added with Nicotine Level:", tempProduct); // Debug log
//         state.cartItems.push(tempProduct);
//       }
//      toast.success("Item added to cart") 
//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },
//     getTotals(state, action) {
//       let { total, quantity } = state.cartItems.reduce(
//         (cartTotal, cartItem) => {
//           const { price,originalPrice, cartQuantity } = cartItem;
//           const itemPrice = price > 0 ? price : originalPrice; 
//           const itemTotal = itemPrice * cartQuantity;

//           cartTotal.total += itemTotal;
//           cartTotal.quantity += cartQuantity;

//           return cartTotal;
//         },
//         {
//           total: 0,
//           quantity: 0,
//         }
//       );
//       total = parseFloat(total.toFixed(2));
//       state.cartTotalQuantity = quantity;
//       state.cartTotalAmount = total;
//     },
//     emptyCart(state){
//       state.cartItems=[];
//       state.cartTotalQuantity=0;
//       state.cartTotalAmount=0;
//       toast.success("Items removed from the cart")
//       localStorage.removeItem('cartItems');
//     }
//   },
// });

// export const { addToCart, removeFromCart,decreaseCart,incrementCart, getTotals,addByIncrement, emptyCart} = CartSlice.actions;

// export const cartReducer = CartSlice.reducer;





// import { createSlice } from "@reduxjs/toolkit";
// import toast from "react-hot-toast";

// const initialState = {
//   cartItems: localStorage.getItem("cartItems")
//     ? JSON.parse(localStorage.getItem("cartItems"))
//     : [],
//   cartTotalQuantity: 0,
//   cartTotalAmount: 0,
//   selectedNicotineLevel: 0
// };

// export const CartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {
//     addToCart(state, action) {
//       const productIndex = state.cartItems.findIndex(
//         (item) => item._id === action.payload._id &&
//         item.selectedNicotineLevel === action.payload.selectedNicotineLevel
//       );

//       if (productIndex >= 0) {
//         if (state.cartItems[productIndex].cartQuantity < state.cartItems[productIndex].quantity) {
//           state.cartItems[productIndex].cartQuantity += 1;
//           toast.success("Item added to cart");
//         } else {
//           toast.error(`Only ${state.cartItems[productIndex].quantity} available in stock`);
//         }
//       } else {
//         if (action.payload.quantity > 0) {
//           const tempProduct = { ...action.payload, cartQuantity: 1,selectedNicotineLevel: action.payload.selectedNicotineLevel, };
//           state.cartItems.push(tempProduct);
//           toast.success("Item added to cart");
//         } else {
//           toast.error("Out of stock");
//         }
//       }

//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },

//     incrementCart(state, action) {
//       const productIndex = state.cartItems.findIndex(
//         (item) => item._id === action.payload._id &&
//         item.selectedNicotineLevel === action.payload.selectedNicotineLevel
//       );

//       if (productIndex >= 0) {
//         if (state.cartItems[productIndex].cartQuantity < state.cartItems[productIndex].quantity) {
//           state.cartItems[productIndex].cartQuantity += 1;
//           toast.success("Item added to cart");
//         } else {
//           toast.error(`Only ${state.cartItems[productIndex].quantity} available in stock`);
//         }
//       }

//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },

//     addByIncrement(state, action) {
//       const productIndex = state.cartItems.findIndex(
//         (item) => item._id === action.payload.product._id
//       );

//       if (productIndex >= 0) {
//         const availableQuantity = state.cartItems[productIndex].quantity;
//         const newQuantity = state.cartItems[productIndex].cartQuantity + action.payload.cartQuantity;

//         if (newQuantity <= availableQuantity) {
//           state.cartItems[productIndex].cartQuantity = newQuantity;
//           toast.success("Item added to cart");
//         } else {
//           toast.error(`Only ${availableQuantity} available in stock`);
//         }
//       } else {
//         if (action.payload.product.quantity >= action.payload.cartQuantity) {
//           const tempProduct = { ...action.payload, cartQuantity: 1,selectedNicotineLevel: action.payload.selectedNicotineLevel, };
//           state.cartItems.push(tempProduct);
//           toast.success("Item added to cart");
//         } else {
//           toast.error(`Only ${action.payload.product.quantity} available in stock`);
//         }
//       }

//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },

//     removeFromCart(state, action) {
//       state.cartItems = state.cartItems.filter((item) => item._id !== action.payload._id);
//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },

//     decreaseCart(state, action) {
//       const productIndex = state.cartItems.findIndex(
//         (item) => item._id === action.payload._id
//       );

//       if (productIndex >= 0) {
//         if (state.cartItems[productIndex].cartQuantity > 1) {
//           state.cartItems[productIndex].cartQuantity -= 1;
//         } else {
//           state.cartItems = state.cartItems.filter((item) => item._id !== action.payload._id);
//           toast.success("Item removed from cart");
//         }
//       }

//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },

//     getTotals(state) {
//       let { total, quantity } = state.cartItems.reduce(
//         (cartTotal, cartItem) => {
//           const { price, originalPrice, cartQuantity } = cartItem;
//           const itemPrice = price > 0 ? price : originalPrice;
//           const itemTotal = itemPrice * cartQuantity;

//           cartTotal.total += itemTotal;
//           cartTotal.quantity += cartQuantity;

//           return cartTotal;
//         },
//         {
//           total: 0,
//           quantity: 0,
//         }
//       );

//       state.cartTotalQuantity = quantity;
//       state.cartTotalAmount = parseFloat(total.toFixed(2));
//     },

//     emptyCart(state) {
//       state.cartItems = [];
//       state.cartTotalQuantity = 0;
//       state.cartTotalAmount = 0;
//       toast.success("Items removed from the cart");
//       localStorage.removeItem("cartItems");
//     }
//   },
// });

// export const { addToCart, removeFromCart, decreaseCart, incrementCart, getTotals, addByIncrement, emptyCart } = CartSlice.actions;

// export const cartReducer = CartSlice.reducer;





import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

const initialState = {
  cartItems: localStorage.getItem("cartItems")
    ? JSON.parse(localStorage.getItem("cartItems"))
    : [],
  cartTotalQuantity: 0,
  cartTotalAmount: 0,
  selectedNicotineLevel: 0
};

export const CartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart(state, action) {
      const productIndex = state.cartItems.findIndex(
        (item) =>
          item._id === action.payload._id &&
          item.selectedNicotineLevel === action.payload.selectedNicotineLevel
      );

      if (productIndex >= 0) {
        // Check if cart quantity is less than available stock
        const product = state.cartItems[productIndex];
        if (product.cartQuantity < product.quantity) {
          product.cartQuantity += 1;
          toast.success("Item added to cart");
        } else {
          toast.error(`Only ${product.quantity} available in stock`);
        }
      } else {
        // Ensure item is not out of stock before adding it to the cart
        if (action.payload.quantity > 0) {
          const tempProduct = { ...action.payload, cartQuantity: 1, selectedNicotineLevel: action.payload.selectedNicotineLevel, selectedAttributes: action.payload.selectedAttributes || {}, };
          state.cartItems.push(tempProduct);
          toast.success("Item added to cart");
        } else {
          toast.error("Out of stock");
        }
      }

      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    removeFromCart(state, action) {
      state.cartItems = state.cartItems.filter((item) => item._id !== action.payload._id);
      toast.success("Item removed from cart");
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    decreaseCart(state, action) {
      const productIndex = state.cartItems.findIndex(
        (item) => item._id === action.payload._id
      );

      if (productIndex >= 0) {
        if (state.cartItems[productIndex].cartQuantity > 1) {
          state.cartItems[productIndex].cartQuantity -= 1;
        } else {
          state.cartItems = state.cartItems.filter((item) => item._id !== action.payload._id);
          toast.success("Item removed from cart");
        }
      }

      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    incrementCart(state, action) {
      const productIndex = state.cartItems.findIndex(
        (item) =>
          item._id === action.payload._id &&
          item.selectedNicotineLevel === action.payload.selectedNicotineLevel
      );

      if (productIndex >= 0) {
        const product = state.cartItems[productIndex];
        // Ensure the quantity does not exceed available stock
        if (product.cartQuantity < product.quantity) {
          product.cartQuantity += 1;
          toast.success("Item added to cart");
        } else {
          toast.error(`Only ${product.quantity} available in stock`);
        }
      } else {
        const tempProduct = { ...action.payload, cartQuantity: 1, selectedNicotineLevel: action.payload.selectedNicotineLevel };
        state.cartItems.push(tempProduct);
        toast.success("Item added to cart");
      }

      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    addByIncrement(state, action) {
      const productIndex = state.cartItems.findIndex(
        (item) => item._id === action.payload.product._id
      );

      if (productIndex >= 0) {
        const availableQuantity = state.cartItems[productIndex].quantity;
        const newQuantity = state.cartItems[productIndex].cartQuantity + action.payload.cartQuantity;

        // Ensure the new quantity doesn't exceed available stock
        if (newQuantity <= availableQuantity) {
          state.cartItems[productIndex].cartQuantity = newQuantity;
          toast.success("Item added to cart");
        } else {
          toast.error(`Only ${availableQuantity} available in stock`);
        }
      } else {
        // Ensure the item is not out of stock before adding it
        if (action.payload.product.quantity >= action.payload.cartQuantity) {
          const tempProduct = {
            ...action.payload.product,
            cartQuantity: action.payload.cartQuantity,
            selectedNicotineLevel: action.payload.selectedNicotineLevel,
          };
          state.cartItems.push(tempProduct);
          toast.success("Item added to cart");
        } else {
          toast.error(`Only ${action.payload.product.quantity} available in stock`);
        }
      }

      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    getTotals(state) {
      let { total, quantity } = state.cartItems.reduce(
        (cartTotal, cartItem) => {
          const { price, originalPrice, cartQuantity } = cartItem;
          const itemPrice = price > 0 ? price : originalPrice;
          const itemTotal = itemPrice * cartQuantity;

          cartTotal.total += itemTotal;
          cartTotal.quantity += cartQuantity;

          return cartTotal;
        },
        {
          total: 0,
          quantity: 0,
        }
      );

      state.cartTotalQuantity = quantity;
      state.cartTotalAmount = parseFloat(total.toFixed(2));
    },

    emptyCart(state) {
      state.cartItems = [];
      state.cartTotalQuantity = 0;
      state.cartTotalAmount = 0;
      toast.success("Items removed from the cart");
      localStorage.removeItem("cartItems");
    }
  },
});

export const { addToCart, removeFromCart, decreaseCart, incrementCart, getTotals, addByIncrement, emptyCart } = CartSlice.actions;

export const cartReducer = CartSlice.reducer;

